// extracted by mini-css-extract-plugin
export default {"actions":"ForgotPassword_actions__KLimK"};